export default {
    props: {
        dropzoneUrl: String,
        acceptedFiles: String,
        maxSize: Number,
        clickable: Boolean,
    },

    data () {
        return {
            dropzoneOptions: {
                url: this.dropzoneUrl,
                maxFilesize: this.maxSize,
                clickable: this.clickable ? this.clickable : false,
                createImageThumbnails: false,
                uploadMultiple: false,
                parallelUploads: 10,
                previewsContainer: false,
                acceptedFiles: this.acceptedFiles,
                headers: {"X-CSRF-TOKEN": window.axios.defaults.headers.common["X-CSRF-TOKEN"]},
            },
            processingUpload: false,
            processingPercentage: 0,
            fileName: "",
        };

    },

    methods: {
        processingFileUpload (file, progress, bytesSent) {
            this.processingUpload = true;
            this.fileName = file.name;
            this.processingPercentage = progress;
        },

        fileUploadCompletedOrFailed (response) {
            this.processingUpload = false;
            this.processingPercentage = 0;
        },
    }

};
